import IconBase from './icon-base';

const IconThermalResistance = ({
  className,
  fill = '#000000',
  height = '24px',
  hoverColor = '#000000',
  width = '24px',
}) => (
  <IconBase
    className={className}
    fill={fill}
    height={height}
    hoverColor={hoverColor}
    viewBox="4 4.857 24 22.285"
    width={width}
  >
    <path d="M28 7.09771L26.8729 7.47228C25.2939 7.96693 23.654 8.24067 22 8.28571C20.5137 8.28571 19.1526 7.50828 17.7109 6.68457C16.1389 5.78628 14.5137 4.85714 12.5714 4.85714C10.1054 4.85714 7.35571 6.748 5.71429 8.09028L4 9.99999V25.4286C4.00045 25.8831 4.18121 26.3189 4.5026 26.6403C4.824 26.9616 5.25977 27.1424 5.71429 27.1429H28V7.09771ZM5.71429 18.8234C7.32057 16.3223 10.48 12.5714 12.5714 12.5714C13.9754 12.5714 15.1086 13.516 16.3086 14.5163C17.626 15.6134 19.1183 16.8571 21.1429 16.8571C23.0595 16.7652 24.8816 15.9972 26.2857 14.6894V18.9374C24.7053 19.7951 22.9408 20.2577 21.1429 20.2857C19.7676 20.2491 18.4091 19.9738 17.128 19.4723C15.6729 18.9099 14.1311 18.605 12.5714 18.5714C10.0626 18.5714 7.37029 21.1077 5.71429 22.9926V18.8234ZM12.5714 6.57143C14.0577 6.57143 15.4189 7.34885 16.8606 8.17257C18.4326 9.07085 20.0577 10 22 10C23.4465 9.97571 24.885 9.78064 26.2857 9.41885V12.2654C25.7003 12.9537 23.6423 15.1429 21.1429 15.1429C19.7389 15.1429 18.6057 14.1983 17.4057 13.198C16.0883 12.1009 14.596 10.8571 12.5714 10.8571C10.0549 10.8571 7.37457 13.72 5.71429 15.8671V10.3634C7.03943 9.11371 10.222 6.57143 12.5714 6.57143ZM5.92771 25.4286C7.31029 23.6363 10.3514 20.2857 12.5714 20.2857C13.9467 20.3224 15.3052 20.5976 16.5863 21.0991C18.0414 21.6616 19.5832 21.9664 21.1429 22C22.9188 21.983 24.6712 21.5916 26.2857 20.8514V25.4286H5.92771Z" />
  </IconBase>
);

export default IconThermalResistance;
